import React from 'react'

const Instagram = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1765 2H7.10572C4.32474 2 2.07031 4.23858 2.07031 7V17C2.07031 19.7614 4.32474 22 7.10572 22H17.1765C19.9575 22 22.2119 19.7614 22.2119 17V7C22.2119 4.23858 19.9575 2 17.1765 2Z"
        stroke="#181919"
        stroke-width="1.03293"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.1693 11.3699C16.2936 12.2022 16.1505 13.0522 15.7602 13.799C15.37 14.5457 14.7525 15.1513 13.9957 15.5296C13.2388 15.9079 12.3811 16.0395 11.5446 15.9059C10.7081 15.7722 9.93526 15.38 9.33612 14.7851C8.73699 14.1902 8.34203 13.4228 8.20742 12.5921C8.0728 11.7615 8.2054 10.9098 8.58634 10.1583C8.96728 9.40679 9.57717 8.79368 10.3293 8.40618C11.0813 8.01868 11.9373 7.87652 12.7755 7.99994C13.6304 8.12582 14.4219 8.5214 15.033 9.12824C15.6442 9.73508 16.0426 10.521 16.1693 11.3699Z"
        stroke="#181919"
        stroke-width="1.03293"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.6802 6.5H17.6902"
        stroke="#181919"
        stroke-width="1.03293"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default Instagram
